(function () {
    const MAX_CHARS = 110;

    document.querySelectorAll('.Application__desc').forEach((desc) => {
        const toggle = desc.nextElementSibling;
        if (!toggle || !toggle.classList.contains('Application__toggle')) return;

        const moreLabel = toggle.dataset.more || 'Rozwiń';
        const lessLabel = toggle.dataset.less || 'Zwiń';

        const fullText  = desc.textContent.trim();

        if (fullText.length <= MAX_CHARS) {
            toggle.style.display = 'none';
            return;
        }

        const shortText = fullText.slice(0, MAX_CHARS).trimEnd() + '…';

        desc.textContent   = shortText;
        toggle.textContent = moreLabel;
        toggle.style.display = 'block';

        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                desc.textContent = shortText;
                toggle.textContent = moreLabel;
                toggle.setAttribute('aria-expanded', 'false');
            } else {
                desc.textContent = fullText;
                toggle.textContent = lessLabel;
                toggle.setAttribute('aria-expanded', 'true');
            }
        });
    });
})();